import { render } from "./LiveFeeds.vue?vue&type=template&id=eaab7bec&scoped=true"
import script from "./LiveFeeds.vue?vue&type=script&lang=js"
export * from "./LiveFeeds.vue?vue&type=script&lang=js"

import "./LiveFeeds.vue?vue&type=style&index=0&id=eaab7bec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaab7bec"]])

export default __exports__